var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C15.448 7 15 7.4477 15 8C15 8.5523 15.448 9 16 9H21C21.552 9 22 8.5523 22 8C22 7.4477 21.552 7 21 7H16ZM15 11C14.448 11 14 11.4477 14 12C14 12.5523 14.448 13 15 13H21C21.552 13 22 12.5523 22 12C22 11.4477 21.552 11 21 11H15ZM18 15C17.448 15 17 15.4477 17 16C17 16.5523 17.448 17 18 17H21C21.552 17 22 16.5523 22 16C22 15.4477 21.552 15 21 15H18Z",
    fill: "#F36D25",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.5C4 5.015 6.015 3 8.5 3C10.985 3 13 5.015 13 7.5C13 9.985 10.985 12 8.5 12C6.015 12 4 9.985 4 7.5Z",
    fill: "#F36D25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 15.956 3.22801 14.101 5.06201 13.344C5.31801 13.238 5.59199 13.26 5.84399 13.375C6.75999 13.792 7.625 14 8.5 14C9.378 14 10.24 13.803 11.125 13.406C11.381 13.292 11.68 13.295 11.938 13.406C13.765 14.194 15 16.004 15 18V20C15 20.552 14.552 21 14 21H3C2.448 21 2 20.552 2 20V18Z",
    fill: "#F36D25"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveClients);
export default __webpack_public_path__ + "static/media/activeClients.efa0d7c3ba28efa9b514a1a954bd1e9b.svg";
export { ForwardRef as ReactComponent };